// SolyticsNoDataPresent.jsx
// @ts-nocheck
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as NoDocumentIcon } from '../../assets/Icons/lucideIcons/file-search-corner.svg';

import SolyticsBox from './SolyticsBox';
import SolyticsTypography from './SolyticsTypography';

const DEFAULT_HEIGHT = '300px';
const SolyticsNoDataPresent = ({
  message = 'No data Present.',
  Icon = NoDocumentIcon,
  variant = 'text', //text,iconWithText
  height = DEFAULT_HEIGHT,
}) => {
  return (
    <SolyticsBox
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: variant === 'iconWithText' ? '8px' : '0px',
        color: (theme) => theme.palette.primary.main, // Set the color context
        height: height,
        width: '100%',
      }}
    >
      {variant === 'iconWithText' && <Icon />}
      <SolyticsTypography
        variant="subtitle1"
        noWrap
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '600px',
        }}
        title={message}
      >
        {message}
      </SolyticsTypography>
    </SolyticsBox>
  );
};

SolyticsNoDataPresent.propTypes = {
  message: PropTypes.node.isRequired,
  Icon: PropTypes.elementType,
  variant: PropTypes.oneOf(['text', 'iconWithText']),
  height: PropTypes.string,
};

export default SolyticsNoDataPresent;
